module.exports = __webpack_public_path__ + "img/dongji_ps_27.7b81ec3d.jpg";